import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { get } from 'lodash';
import { useMemo } from 'react';

export const GET_TASK_PROGRESS = gql`
  query GetTaskProgress($ids: [String!]!) {
    taskProgress(ids: $ids) {
      id
      calculatedHoursRemaining
      calculatedEstimatedCompletionDate
      actualHoursToDate
      initialEstimate
    }
  }
`;

export const useGetTaskProgress = ({ ids }) => {
  const inputVariables = useMemo(
    () => ({
      ids
    }),
    [ids]
  );

  const { data, loading } = useQuery(GET_TASK_PROGRESS, {
    variables: inputVariables,
    skip: !ids.length,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  const taskProgress = get(data, 'taskProgress', []);

  return {
    loading,
    taskProgress
  };
};

export default useGetTaskProgress;
